/** Reference distance for admin “tokens per 1000 km” preview (matches revenue at 1000 km). */
export const REFERENCE_DISTANCE_KM = 1000;

/**
 * Gross base tokens for a 1000 km haul before payout deductions.
 * revenue = distanceKm × tonnes × €/(t·km); baseTokens = floor(revenue).
 *
 * @param {number} pricePerKm - € per tonne·km
 * @param {number} weightTonnes - cargo mass in tonnes
 * @returns {number|null}
 */
export function computeBaseTokensPer1000Km(pricePerKm, weightTonnes) {
  if (pricePerKm === '' || pricePerKm == null || weightTonnes === '' || weightTonnes == null) {
    return null;
  }
  const rate = Number(pricePerKm);
  const tonnes = Number(weightTonnes);
  if (!Number.isFinite(rate) || rate < 0 || !Number.isFinite(tonnes) || tonnes <= 0) {
    return null;
  }
  return Math.floor(rate * REFERENCE_DISTANCE_KM * tonnes);
}

/**
 * @param {number|null|undefined} preview - from API or local compute
 * @returns {string}
 */
export function formatBaseTokensPer1000Km(preview) {
  if (preview == null || !Number.isFinite(Number(preview))) return '—';
  return Number(preview).toLocaleString();
}

/**
 * @param {number|string} pricePerKm
 * @param {number|null|undefined} weightTonnes
 * @returns {number|null}
 */
export function previewBaseTokensFromForm(pricePerKm, weightTonnes) {
  return computeBaseTokensPer1000Km(pricePerKm, weightTonnes);
}
